<template>
  <v-footer
    color="transparent"
    class="PoweredBy text-xs-center pa-0 mt-4 mb-2">
    <v-container :class="isMobile ? 'pa-1' : ''">
      <v-row
        no-gutters>
        <v-col
          xs="12"
          class="align-content-center flex-wrap">
          <v-card
            flat
            class="transparent d-flex justify-center">
            <a
              v-if="displayText"
              :href="`${externalLinks.siteHome}`"
              target="_blank"
              class="PoweredBy__link black--text caption d-flex align-content-center"
            >
              <v-img
                :height="isMobile ? '24px' : '36px'"
                :width="isMobile ? '24px' : '36px'"
                :max-width="isMobile ? '24px' : '36px'"
                src="/assets/logo/color_128.png"
                contain
                class="PoweredBy__link--logo mr-3" />

              <div :class="isMobile ? '' : 'pt-2'">{{ $t('home.poweredBy') }}
                <span class="font-weight-bold mr-1">
                  {{ $t('home.gmelius') }}
                </span>
              </div>
            </a>
          </v-card>

        </v-col>
      </v-row>
    </v-container >
  </v-footer>
</template>
<script>
import { localeMixin, isMobileMixin } from '../mixins'
import { externalLinks } from '../config'

export default {
  mixins: [localeMixin, isMobileMixin],
  props: {
    displayText: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      externalLinks,
      loaded: false
    }
  }
}
</script>
<style lang="scss">
.PoweredBy {
  &__link {
    background: rgba(white, 0.85);
    padding: 8px 12px;
    border-radius: 32px !important
  }
}
</style>
